var map = {
	"./0.svg": 7403,
	"./1.svg": 8586,
	"./10.svg": 7622,
	"./11.svg": 7159,
	"./12.svg": 5652,
	"./13.svg": 581,
	"./14.svg": 5306,
	"./15.svg": 923,
	"./16.svg": 9560,
	"./17.svg": 1305,
	"./18.svg": 5134,
	"./19.svg": 4063,
	"./2.svg": 4233,
	"./20.svg": 1291,
	"./21.svg": 6682,
	"./22.svg": 4793,
	"./23.svg": 6904,
	"./24.svg": 9735,
	"./25.svg": 1702,
	"./26.svg": 4133,
	"./27.svg": 2964,
	"./28.svg": 4659,
	"./29.svg": 3138,
	"./3.svg": 1864,
	"./30.svg": 3992,
	"./4.svg": 4263,
	"./5.svg": 7398,
	"./6.svg": 7685,
	"./7.svg": 6052,
	"./8.svg": 3091,
	"./9.svg": 9778
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1085;